<template>
	<div>
		<v-fade-transition mode="out-in">
			<router-view v-if="appLoaded" />
		</v-fade-transition>
		<v-app style="position: absolute;min-height: 0;bottom: 0;">
			<v-snackbars :objects.sync="toastOjects" bottom left>
				<template v-slot:action="{ close }">
					<v-icon dark @click="close()">
						mdi-close-circle-outline
					</v-icon>
				</template>
			</v-snackbars>
		</v-app>
	</div>
</template>

<script>
// Styles
import { call, get } from 'vuex-pathify'
import { initAnalytics } from '@/services/analytics.js'
import '@/styles/overrides.sass'

export default {
	name: 'App',
	data() {
		return {
			appLoaded: false,
		}
	},
	computed: {
		...get('siteConfig', [
			'longTitle', 'fullTitle', 'titlePart2', 'isCloud'
		]),
		toastOjects: {
			get() {
				return this.$store.state.toast.objects
			},
			set(val) {
				this.$store.dispatch('toast/update', val)
			},
		},
	},
	created() {
	},
	mounted() {
		this.loadSiteConfig().then(res => {
			let title = this.longTitle
			if (window.location.hostname.indexOf('kianvam.ir') > -1) {
				title = '9849887'
			}
			this.$metaInfo.title = title
			this.$metaInfo.titleTemplate = title

			if (document.title != title) {
				document.title = title
			}
			let permitSitesForCrisp = ['jetaqsaat', 'vamcity']
			if (permitSitesForCrisp.some(x => window.location.hostname.indexOf(x) > -1)) {
				var crisp = document.createElement('script')
				crisp.type = 'text/javascript'
				crisp.src = '/crisp.js'
				document.head.appendChild(crisp)
			}
			let permitSitesForNavachat = ['arvandkalaa']
			if (permitSitesForNavachat.some(x => window.location.hostname.indexOf(x) > -1)) {
				var navachat = document.createElement('script')
				navachat.type = 'text/javascript'
				navachat.src = '/navachat.js'
				document.head.appendChild(navachat)
			}
			initAnalytics(this.isCloud)
			this.appLoaded = true
		})
	},
	metaInfo() {
		return {
			title: 'سیستم مدیریت اقساط',
			titleTemplate: 'سیستم مدیریت اقساط',
			htmlAttrs: { lang: 'en' },
			meta: [
				{ charset: 'utf-8' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
			],
		}
	},
	methods: {
		loadSiteConfig: call('siteConfig/fetch'),
	}
}
</script>
